/**
 *
 * Module:        Component
 * Name:          Guru Sidebar Section Header
 * Description:   Renders a shared collapsible sidebar heading
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import QeeTooltip from '../qeeTooltip';
import {GURU_BODY_FONT_SIZE} from './guruTypography';

export default function GuruSidebarSectionHeader({label, expanded, onToggle}) {
	return (
		<Box sx={{display: 'flex', alignItems: 'center', minHeight: 44, px: 2, pt: 0.75, pb: 0.25}}>
			<Typography sx={{flex: '1 1 auto', minWidth: 0, fontSize: GURU_BODY_FONT_SIZE, fontWeight: 500, color: 'text.secondary'}}>
				{label}
			</Typography>
			<QeeTooltip title={label}>
				<IconButton
					size="small"
					onClick={onToggle}
					aria-label={label}
					aria-expanded={expanded}
					sx={{ml: 0.5, color: 'text.secondary'}}
				>
					<ExpandMoreIcon sx={{fontSize: 19, transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 120ms'}} />
				</IconButton>
			</QeeTooltip>
		</Box>
	);
}
